<template>
    <div class="w-full">
        <div
            class="w-full h-2 mb-2
                  transition-all"
        >
            <input
                type="range"
                id="progress"
                class="
                  overflow-hidden
                  appearance-none
                  bg-grey-light
                  h-full
                  w-full
                  cursor-pointer
                "
                min="0"
                max="100"
                step="0.1"
                :value="(watchTime / duration) * 100"
                @input="
                    (e) =>
                        $emit('changeTime', (e.target.value * duration) / 100)
                "
            />
        </div>
        <div
            class="bg-black w-full h-12 bg-opacity-50 flex flex-row justify-between items-center "
        >
            <div class="flex flex-row items-center justify-center ml-2 py-1">
                <icon-container
                    class="bg-white-dark bg-opacity-0 hover:bg-opacity-10 transition-all mr-2"
                    :icon="isPlaying ? 'PauseIcon' : 'PlayIcon'"
                    :iconSize="'5'"
                    :size="'w-10 pt-3 h-10'"
                    iconFill="fill-white"
                    @click="$emit('togglePlay')"
                />
                <div
                    class="ml-3 text-white font-semibold text-sm select-none hidden xs:block"
                >
                    {{ computedTime }}
                </div>
            </div>
            <div
                class="flex flex-row w-full justify-end  items-center mr-2 py-1"
            >
                <div class="w-32" style="max-width:calc(100% - 150px)">
                    <slider
                        :height="8"
                        :modelValue="volume"
                        color="#D0A97E"
                        track-color="#ffffff"
                        @change="(e) => $emit('volumeChange', e)"
                    />
                </div>
                <icon-container
                    class="bg-white-dark bg-opacity-0 hover:bg-opacity-10 transition-all mx-3"
                    :icon="computedVolumeIcon"
                    :iconSize="'5'"
                    :size="'w-10 pt-3 h-10'"
                    iconFill="fill-white"
                    @click="$emit('toggleMute')"
                />
                <icon-container
                    class="bg-white-dark bg-opacity-0 hover:bg-opacity-10 transition-all"
                    icon="FullscreenIcon"
                    :iconSize="'5'"
                    :size="'w-10 pt-3 h-10'"
                    iconFill="fill-white"
                    @click="$emit('requestFullscreen')"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { computed, defineComponent, reactive } from "@vue/runtime-core";
import { useStore } from "vuex";
import IconContainer from "../../../../components/helper/IconContainer.vue";
import { SLIDE_TYPES, STORE_TYPES } from "../../../../store/types";
import slider from "vue3-slider";
export default defineComponent({
    props: {
        isPlaying: { type: Boolean, required: true },
        watchTime: { type: Number, required: true },
        duration: { type: Number, required: true },
        volume: { type: Number, required: true },
    },
    emits: [
        "volumeChange",
        "togglePlay",
        "requestFullscreen",
        "toggleMute",
        "changeTime",
    ],
    components: { IconContainer, slider },
    setup(props) {
        const store = useStore();
        /**
         *  State
         */
        const state = reactive({ myNumber: 30 });
        /**
         *  Functions
         */
        function convertTime(time) {
            var minutes = Math.floor(time / 60);
            var seconds = Math.floor(time % 60);
            var hours = Math.floor(minutes / 60);
            minutes = minutes - hours * 60;
            if (seconds < 10) {
                seconds = "0" + seconds;
            }
            if (hours != 0) {
                if (minutes <= 10) {
                    minutes = "0" + minutes;
                }
                return hours + ":" + minutes + ":" + seconds;
            } else {
                return minutes + ":" + seconds;
            }
        }
        /**
         *  Computed
         */
        const GET_SLIDE = computed(
            () =>
                store.getters[`${STORE_TYPES.SLIDES}/${SLIDE_TYPES.GET_SLIDE}`]
        );
        const computedVolumeIcon = computed(() => {
            if (props.volume == 0) {
                return "VolumeCanceledIcon";
            } else if (props.volume < 25) {
                return "VolumeIcon";
            } else if (props.volume < 60) {
                return "VolumeSmallIcon";
            } else {
                return "VolumeFullIcon";
            }
        });
        const computedTime = computed(() => {
            const watchTime = convertTime(props.watchTime);
            const duration = convertTime(props.duration);
            return `${watchTime}/${duration}`;
        });

        /**
         *  Created
         */

        return { state, GET_SLIDE, computedTime, computedVolumeIcon };
    },
});
</script>
<style lang="scss" scoped>
#progress::-webkit-slider-thumb {
    width: 12px;
    -webkit-appearance: none;
    appearance: none;
    height: 12px;
    cursor: pointer;
    background: #fff;
    box-shadow: -805px 0 0 800px #d0a97e;
    border-radius: 0%;
}
</style>
